<script>
    import { homeURL, apiURL } from '../../store.js'
    import { fireHashChange } from '../../js/hash-scroll.js'

    export let page
    export let label
    export let index = 0
    export let hash = null
    export let subSection = false
</script>

<div class="sidebarItem" class:subItem={subSection} class:inputItem={hash === null}>
    {#if subSection === false}
        <img
            class="circuitPart"
            src="{apiURL}{page.circuit_parts[index % page.circuit_parts.length].url}"
            onload="SVGInject(this)"
            alt={page.circuit_file.title}
        />
    {/if}
    {#if hash === null}
        <p>{label}</p>
    {:else}
        <a
            href="{homeURL}/{page.meta.slug}#!{hash}"
            on:click={e => fireHashChange(e, hash, page.meta.slug)}
        >
            {label}
        </a>
    {/if}
</div>

<style lang="scss">
@import "../../styles/vars";

.sidebarItem {
    position: relative;
    display: flex;
    align-items: center;
    gap: 5px;
    font-family: 'Work Sans', Helvetica;
    font-weight: 600;
    font-size: 1.25em;
    margin: 20px 0;
    padding: 0;
    padding-right: 1rem;
    font-feature-settings: 'ss01', 'ss06';

    * {
        vertical-align: middle;
    }

    &:hover {
        text-decoration: none;

        :global(svg *) {
            fill: var(--pageColor) !important;
        }
    }
}

.subItem {
    font-weight: 300;
    font-size: 1em;
    padding-left: 1rem;
    margin: 12px 0;
}

.inputItem {
    margin: 0;
}

.circuitPart {
    position: relative;
    display: inline;
    line-height: 100%;
    width: 30px;
    margin-left: -35px;
}

p {
    margin: 0;
}

a {
    color: black;
    text-decoration: none;
}

@include respond-to(phone) {
    .sidebarItem {
        margin: 0.5rem;
    }

    .subItem {
        padding-left: 5px !important;
        font-size: 0.9rem;
        line-height: 1.1rem;
    }
}
</style>
